import { Components, PaletteOptions } from "@mui/material";
import { TypographyOptions } from "@mui/material/styles/createTypography";

export const typographyProperties: TypographyOptions = {
  htmlFontSize: 16,
  fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 600,
    fontSize: "48px",
    lineHeight: "64px",
    letterSpacing: "0",
  },
  h2: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 700,
    fontSize: "42px",
    lineHeight: "56px",
    letterSpacing: "-0.00833em",
  },
  h3: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 600,
    fontSize: "36px",
    lineHeight: "48px",
    letterSpacing: "0",
  },
  h4: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 600,
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "0.25px",
  },
  h5: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "30px",
    letterSpacing: "0.3px",
  },
  h6: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "28px",
    letterSpacing: "0.15px",
  },
  subtitle1: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "28px",
    letterSpacing: "0.15px",
  },
  subtitle2: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 700,
    fontSize: "15px",
    lineHeight: "22px",
    letterSpacing: "0.1px",
  },
  body1: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    letterSpacing: "0.15px",
  },
  body1medium: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    letterSpacing: " 0.15px",
  },
  body2: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.15px",
  },
  body1SemiBold: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "22px",
    letterSpacing: "0.15px",
  },
  body2Semibold: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "18px",
    letterSpacing: "0.15px",
  },
  body2medium: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.15px",
  },
  buttonMedium: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "0.4px",
  },
  button: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "26px",
    letterSpacing: "0.46px",
    textTransform: "capitalize",
    borderRadius: "4px",
  },
  caption: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "15px",
    letterSpacing: "0.4px",
  },
  overline: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "1px",
    textTransform: "uppercase",
  },
  avatarLetter: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "20px",
    letterSpacing: "0.14px",
  },
  inputLevel: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "12px",
    letterSpacing: "0.15px",
  },
  helperText: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "14px",
    letterSpacing: "0.4px",
  },
  chipLight: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 400,
    fontSize: "13px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
  },
  inputText: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
  },
  tooltip: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 400,
    fontSize: "10px",
    lineHeight: "14px",
    letterSpacing: "0",
  },
  badge: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "20px",
    letterSpacing: "0.14px",
  },
  chipMedium: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
  },
  TableHeader: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "24px",
    letterSpacing: "0.17px",
  },
  alert: {
    fontFamily: ["Poppins", "Arial", "sans-serif"].join(","),
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "28px",
    letterSpacing: "0.15px",
  },
  helperText2: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "12px",
    letterSpacing: "0.15px",
  },
};

export const lightModePalette: PaletteOptions = {
  mode: "light",
  common: {
    black: "#000000",
    white: "#FFFFFF",
  },
  background: {
    paper: "#FFFFFF",
    default: "#F9FAFB",
  },
  text: {
    primary: "#1C1B1F",
    secondary: "#546376",
  },
  primary: {
    main: "#6258FF", // default
    // light: will be calculated from palette.primary.main,
    // dark: will be calculated from palette.primary.main and palette.action.hover,
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#006DF5",
    contrastText: "#FFFFFF",
  },
  warning: {
    main: "#F2994A",
    contrastText: "#FFFFFF",
    light: "#FFDCC3",
    dark: "#944200",
  },
  error: {
    main: "#ED0039",
    light: "#ffdad9",
    dark: "#940015",
    contrastText: "#FFFFFF",
  },
  info: {
    main: "#A352C2",
    contrastText: "#FFFFFF",
  },
  success: {
    main: "#008945",
    light: "#baf0cb",
    contrastText: "#FFFFFF",
  },
  other: {
    outlinedBorder: "rgba(148, 157, 178, 0.12)",
    btnOutlinedBorder: "rgba(0, 109, 245, 0.5)",
    dividerFillColor: "rgba(148, 157, 178, 0.12)",
    outlinedBorderDarker: "rgba(148, 157, 178, 0.24)",
    lightGray: "#E0E0E0",
    gray: "#eeeeee",
    greyLight: "#c2c2c21f",
    skylight: "#7db3f7",
    secondaryHover: "#006df514",
    pageColor: "#f4f5f7",
    backdrop: "rgb(17 17 17 / 5%)",
    primaryLight: "#D2CCFF",
    primaryDark: "#15008A",
    darkNavy: "#133159",
    grayDark: "#515151",
  },
  action: {
    active: "#949DB2",
    // actionHover: "rgba(98, 88, 255, 0.06)",
    hover: "rgba(100, 56, 188, 0.04)",
    hoverOpacity: 0.03,
    selected: "rgba(28, 15, 19, 0.08)",
    selectedOpacity: 0.08,
    disabled: "rgba(3, 6, 11, 0.26)",
    disabledBackground: "rgba(3, 6, 11, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(28, 15, 19, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12,
  },
};
export const myBreakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
    xxl: 1780,
  },
};
export const ElementProps: Components = {
  MuiChip: {
    variants: [
      {
        props: { size: "xSmall" },
        style: {
          height: 22,
          fontSize: 11,
          "& .MuiChip-icon": {
            fontSize: 14,
          },
          "& .MuiChip-deleteIcon": {
            fontSize: 14,
          },
          "& .MuiChip-label": {
            paddingInline: 8,
          },
        },
      },
    ],
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        borderBottomColor: lightModePalette.other.outlinedBorder,
      },
    },
  },
};
